import { Box } from '@mui/material'
import AssistantMessageContentActions from './AssistantMessageContentActions'
import AssistantMessageContentBody from './AssistantMessageContentBody'
import AssistantMessageContentMenus from './AssistantMessageContentMenus'
import styles from './index.module.scss'

export default function AssistantMessageContentViewShell({
  children,
  revealKey,
  refinementSourceText,
  showActions = true,
  alwaysShowActions = false,
  actionProps,
  vm,
  handlers,
  menuProps,
}) {
  return (
    <Box className={styles.outer}>
      <AssistantMessageContentBody revealKey={revealKey} refinementSourceText={refinementSourceText}>{children}</AssistantMessageContentBody>
      {showActions ? (
        <AssistantMessageContentActions {...actionProps} alwaysShowActions={alwaysShowActions} />
      ) : null}
      <AssistantMessageContentMenus vm={vm} handlers={handlers} {...menuProps} />
    </Box>
  )
}
